import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, Observable, of, take } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class GoogleMapsLoaderService {
	private isLoaded = false;
	private loader$ = new BehaviorSubject<boolean>(false);

	constructor() {
		if (typeof google !== 'undefined' && google.maps) {
			this.isLoaded = true;
			this.loader$.next(true);
		} else {
			window.addEventListener('load', () => {
				this.isLoaded = true;
				this.loader$.next(true);
			});
		}
	}

	waitForGoogleMaps(): Observable<boolean> {
		if (this.isLoaded) {
			return of(true);
		}
		return this.loader$.asObservable().pipe(filter(loaded => loaded), take(1));
	}
}
